import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgentBranchDiscount = id => {
  return http.get(
    `${getBaseUrl()}/agent_branch_discount/${id}`
  );
};

export const postValidateReservationDiscount = (data) => {
  return http.post(
    `${getBaseUrl()}/validate_reservation_discount`,
    data
  );
};

export const postValidateServiceDiscount = (data) => {
  return http.post(
    `${getBaseUrl()}/validate_service_discount`,
    data
  );
};

export const getServiceSecondPaymentDiscount = (data) => {
  return http.get(
    `${getBaseUrl()}/service_second_payment_discount_values/${data.id}`,
    data
  );
};

export const getServiceAgentBranchDiscount = (branchId, discountCode) => {
  return http.get(
    `${getBaseUrl()}/service_branch_discount_code/${branchId}/${discountCode}`
  );
};

export const getAgentBranchDiscounts = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_branch_discount`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_branch_discount?${paginate}`
  );
};

export const updateAgentBranchDiscount = data => {

  return http.put(
    `${getBaseUrl()}/agent_branch_discount/${data.id}`,
    data
  );
};
export const submitAgentBranchDiscount = data => {

  return http.post(
    `${getBaseUrl()}/agent_branch_discount`,
    data
  );
};
